var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-pdf-app',{attrs:{"pdf":_vm.pdfUrl,"config":_vm.viewerConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }